import React, { memo, useCallback } from 'react'
import { ISelectOption } from 'components/forms/Selects'
import { CarrierSelect } from 'apps/fleet-planner/components/atoms'
import * as Types from 'apps/fleet-planner/types'

export interface ICarrierProps {
  /**
   * @default false
   */
  disabled?: boolean
  value: Partial<Types.ILoad>
  refetchOptions: boolean
  /**
   * @default true
   */
  large?: boolean
  /**
   * @default true
   */
  required?: boolean
  selectDefaultOnMount?: boolean
  errors?: {
    motorCarrier?: {
      id?: string
    }
  }
  validationMessage?: string
  onChange: (change: Partial<Types.ILoad>) => void
}

export const Carrier = memo<ICarrierProps>(
  ({
    disabled = false,
    errors: errorsProp,
    large: largeProp = true,
    onChange: onChangeProp,
    refetchOptions,
    required: requiredProp = true,
    selectDefaultOnMount = true,
    validationMessage,
    value: valueProp,
  }) => {
    const { motorCarrier, motorCarrierId: currentMotorCarrierId } = valueProp || {}
    const motorCarrierId = currentMotorCarrierId || motorCarrier?.id || undefined

    const carrierChangeHandler = useCallback(
      ({ label: name, value: motorCarrierIdValue }: ISelectOption<number>) => {
        onChangeProp({
          motorCarrier: motorCarrierIdValue ? { id: motorCarrierIdValue, name } : undefined,
        })
      },
      [onChangeProp]
    )

    return (
      <CarrierSelect
        large={largeProp}
        required={requiredProp}
        label='Carrier'
        motorCarrierId={motorCarrierId}
        onChange={carrierChangeHandler}
        selectDefaultOnMount={selectDefaultOnMount}
        fetchList={refetchOptions}
        validationMessage={validationMessage || errorsProp?.motorCarrier?.id}
        invalid={!!errorsProp?.motorCarrier?.id}
        disabled={disabled}
      />
    )
  }
)
